import React, { createContext, useContext } from 'react';
import { useUnreadMessages } from '../hooks/useUnreadMessages';

const UnreadContext = createContext({
  counts: {},
  total: 0,
  dmCounts: {},
  dmTotal: 0,
  refresh: () => {},
  markChannelRead: () => {},
});

export const UnreadProvider = ({ children }) => {
  const value = useUnreadMessages(10000); // poll every 10s
  return (
    <UnreadContext.Provider value={value}>
      {children}
    </UnreadContext.Provider>
  );
};

export const useUnread = () => useContext(UnreadContext);
